import { Action } from 'redux';
import {
  isFetchDraftsRequestedAction,
  isFetchDraftsSucceededAction,
  isFetchDraftsFailedAction,
  isClearDraftsStateAction,
  isFetchDraftByParentIdRequestedAction,
  isFetchDraftByParentIdSucceededAction,
  isFetchDraftByParentIdFailedAction,
} from '../actions/DraftsActions';
import { Draft, DraftsById, DraftsState } from '../types/DraftsTypes';
import { isDiscardDraftSucceededAction } from '../actions/DiscardDraftAction';


export const InitialDraftsState: DraftsState = {
  drafts: null,
  isBusy: false,
};

export function draftsReducer(previousState = InitialDraftsState, action: Action): DraftsState {
  if (isFetchDraftsRequestedAction(action) || isFetchDraftByParentIdRequestedAction(action)) {
    return({
      ...previousState,
      isBusy: true,
    });
  } else if (isFetchDraftsSucceededAction(action)) {
    return({
      ...previousState,
      drafts: normalizeDraftsByDraftId(action.drafts),
      isBusy: false,
    });
  } else if (isFetchDraftByParentIdSucceededAction(action)){
    return({
      ...previousState,
      drafts: normalizeDraftsByDraftId([action.draft]),
      isBusy: false,
    });
  } else if (isFetchDraftsFailedAction(action) || isFetchDraftByParentIdFailedAction(action)) {
    return ({
      ...previousState,
      drafts: null,
      isBusy: false,
    });
  } else if (isDiscardDraftSucceededAction(action)) {
    return ({
      ...previousState,
      drafts: removeDraftByDraftId(previousState.drafts, action.draftLuid),
    });
   } else if (isClearDraftsStateAction(action)) {
     return ({
       ...previousState,
       drafts: null,
     });
   }

  return previousState;
}

function normalizeDraftsByDraftId(draftArray: Draft[]): DraftsById{
  let drafts: DraftsById = {};

  draftArray.forEach(draft => {
    drafts[draft.draftLuid] = draft;
  });

  return drafts;
}

function removeDraftByDraftId(drafts: DraftsById, draftLuid: string): DraftsById {
  let draftCopy = {...drafts};  //copying so previous state can still be referenced by reducer unit test
  delete draftCopy[draftLuid];
  return draftCopy;
}
